import React, { useEffect, useState } from 'react';
import customHeaders, { getSpace } from '../../common/headers';
import add_icon from './img/add.svg';
import { ButtonBasic } from '@lk-gtcom/ecomlab-components';
import { ArtemBilling2Https } from '../../fetchUrls';
import AddBalanceModal from '../../components/AddBalanceModal';
import useGeneralStore from '../../store/general';
import { Sceleton } from '@lk-gtcom/ecomlab-components'
import './Payment.scss';

interface BalanceResponse {
  balance: number;
  currency: string;
}

const Payment: React.FC = () => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };

  const [isModalBalance, setIsModalBalance] = useState<boolean>(false);
  const [balance, setBalance] = useState<string>('0');
  const [currency, setCurrency] = useState<string>('₽');
  const [loading, setLoading] = useState(true)

  const fetchBalanceCount = async (): Promise<void> => {
    const url = `${ArtemBilling2Https}/balance`;
    setLoading(true)

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(JSON.stringify(error));
      }

      const data: BalanceResponse = await response.json();
      setBalance(data.balance?.toLocaleString());
      setCurrency(data.currency === 'RUB' ? '₽' : data.currency);
      setLoading(false)
    } catch (error) {
      console.error('Failed to fetch balance:', error);
      setLoading(false)
    }
  };

  useEffect(() => {
    fetchBalanceCount();
  }, [selectedSpace]);

  const handleAddBalanceClick = (): void => {
    setIsModalBalance(true);
  };

  const handleModalClose = (): void => {
    setIsModalBalance(false);
  };

  return (
    <>
      {isModalBalance &&
        <AddBalanceModal
          setIsModalActive={handleModalClose}
        />
      }

      <div className="payment">
        {
          loading
            ?
            < Sceleton
              width='100%'
              heyght='100%'
            />
            :
            <div className="payment__content">
              <div className="payment__balance">
                <div className="payment__label">Баланс</div>

                <p className="payment__sum">
                  {balance} {currency}
                </p>

                <ButtonBasic
                  green
                  width='100%'
                  icon={add_icon}
                  text={'Пополнить баланс'}
                  onClick={handleAddBalanceClick}
                />
              </div>
            </div>
        }
      </div>
    </>
  );
};

export { Payment };
